export default "__VITE_ASSET__CcSyzn5F__"